<template>
  <div
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    v-loading="loading"
  >
    <el-col :span="24" class="pingui" v-if="hui">
      <span class="pinspan">{{ dslist.netClassCourseVo.courseName }}</span>
      <span class="pinspan1" v-if="dslist.netClassCourseVo.bookName">{{
        dslist.netClassCourseVo.bookName
      }}</span>
      <el-col :span="24" class="pingui">
        <el-col :span="4">主讲人：{{ dslist.userName }}</el-col>
        <el-col :span="5"
          >学校：{{ dslist.netClassCourseVo.schoolName }}</el-col
        >
        <el-col :span="4" v-if="dslist.lessonViewnum !== null"
          >观课人次：{{ dslist.lessonViewnum }}</el-col
        >
        <el-col :span="4" v-else>观课人次：0</el-col>
        <el-col :span="4">课时：{{ lessonVos.length }}个</el-col>
      </el-col>
    </el-col>
    <el-row :gutter="20">
      <el-col :span="20">
        <img
          src="../../assets/img/wdl.png"
          class="img"
          width="100%"
          v-if="!token && isHaveRight == 0"
          @click="dialogVisible = true"
        />
        <img
          src="../../assets/img/wqx.png"
          class="img"
          width="100%"
          v-if="token && isHaveRight == 0"
        />
        <video-player
          v-if="isHaveRight == 1"
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @ready="playerReadied"
          @timeupdate="onPlayerTimeupdate($event)"
          @ended="onPlayerEnded($event)"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
        <el-col :span="24">
          <el-tabs v-model="activeName">
            <el-tab-pane label="课程介绍" name="first">
              <div
                v-if="courseInfos"
                class="textjieshao"
                v-html="courseInfos"
              ></div>
              <div v-else style="text-align: center">暂无课程介绍...</div>
            </el-tab-pane>
            <el-tab-pane label="回放目录" v-if="huifang">
              <div
                v-for="item in videoVoList"
                :key="item.videoId"
                style="margin-bottom: 15px"
              >
                <el-button
                  @click="xuans(item.videoId, item)"
                  size="mini"
                  :style="
                    item.videoId == lessonsid
                      ? 'background-color: #dd6058;color:#fff'
                      : ''
                  "
                  >回 放</el-button
                >
                <div style="display: inline-block; margin-left: 20px">
                  {{ item.beginTime }} --- {{ item.endTime }}
                </div>
                <!-- .splice(item.fileName.indexOf('.'),4) -->
                <div style="display: inline-block; margin-left: 20px">
                  {{ item.videoTitle }}
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="list.resTypeName"
              :name="list.restypeId.toString()"
              v-for="list in netClassResTypeVos"
              :key="list.restypeId"
            >
              <el-col
                :span="24"
                v-for="dais in list.netClassResPubVos"
                :key="dais.resId"
                class="pinjui"
              >
                <el-col :span="1">
                  <img
                    src="../../assets/img/l-ppt.png"
                    width="20px"
                    style="vertical-align: middle"
                  />
                </el-col>
                <el-col :span="17" style="line-height: 30px">{{
                  dais.resTitle
                }}</el-col>
                <el-col :span="6" style="text-align: right">
                  <el-button type="text" @click="yula(dais.resId)"
                    >预览</el-button
                  >
                </el-col>
              </el-col>
            </el-tab-pane>

            <el-tab-pane label="讨论">
              <el-input
                @focus="focuser"
                type="textarea"
                :rows="4"
                :placeholder="placeholder"
                v-model="textarea"
              ></el-input>
              <div class="xiamip">
                <span class="keshji huidina" @click="lessonfeeling">发表</span>
              </div>
              <el-row>
                <el-col :span="24">全部听课感受（{{ totalCount }}）</el-col>
                <el-col
                  :span="24"
                  class="xiayi"
                  v-for="(list, index) in datalist"
                  :key="index"
                >
                  <el-col :span="2">
                    <el-avatar>{{ list.userName }}</el-avatar>
                  </el-col>
                  <el-col :span="18">
                    <span class="yanse">
                      {{ list.userName }}（{{ list.roleName }}）
                      <span v-if="list.replyRoleType !== ''"
                        >回复 {{ list.replyUserName }}（{{
                          list.replyRoleType
                        }}）</span
                      >
                    </span>
                    <span class="hui">{{ list.createTime }}</span>
                    <el-col :span="24" class="xuehuilig">{{
                      list.feelingContent
                    }}</el-col>
                  </el-col>
                  <el-col :span="4" class="xuehuif">
                    <span class="huijyu huidina" @click="huifu(list)"
                      >回复</span
                    >
                    <span
                      class="huijyu huidina"
                      v-if="userId == list.userId"
                      @click="shanchu(list.feelingId)"
                      >删除</span
                    >
                  </el-col>
                </el-col>
              </el-row>
              <el-pagination
                class="yuanhuif"
                :page-size="5"
                :current-page.sync="curPage"
                @prev-click="gai"
                @next-click="gai"
                @current-change="gai"
                :hide-on-single-page="true"
                background
                layout="prev, pager, next"
                style="margin-top: 15px"
                :total="totalCount"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-col>
      <el-col :span="4">
        <img
          src="../../assets/img/mulu.png"
          width="15px"
          style="vertical-align: middle"
        />
        <span class="dazii">课程目录</span>
        <el-col
          v-if="hui"
          :span="24"
          :class="lessonsid == list.lessonId ? 'keshji' : 'keshji1'"
          v-for="list in lessonVos"
          :key="list.lessonId"
          @click.native="xuan(list.lessonId)"
        >
          {{ list.lessonName }}
          <img
            src="../../assets/img/xue.png"
            width="20px"
            style="float: right"
          />
        </el-col>
        <!-- <el-col
          v-if="hui"
          :span="24"
          :class="lessonsid == list.videoId ? 'keshji' : 'keshji1'"
          v-for="list in videoVoList"
          :key="list.videoId"
          @click.native="xuans(list.videoId, list)"
        >
          第{{ list.videoId }}段
          <img
            src="../../assets/img/xue.png"
            width="20px"
            style="float: right"
          />
        </el-col> -->
      </el-col>
    </el-row>
    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="region">
          <el-select
            v-model="ruleForm.region"
            placeholder="请选择身份"
            style="width: 100%"
          >
            <el-option label="学校管理员" value="school"></el-option>
            <el-option label="老师" value="teacher"></el-option>
            <!-- <el-option label="学生" value="student"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="" prop="input">
          <el-input
            v-model="ruleForm.input"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 100%"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import { videoPlayer } from "vue-video-player";
import "videojs-contrib-hls";
// require('videojs-contrib-hls/dist/videojs-contrib-hls.js')
import "videojs-flash";
import {
  courselesson,
  lessonsetview,
  lessonfeeling,
  lessonfeelinglist,
  lessonfeelingdel,
  note,
  notecheckIsExist,
  lessonSetView,
  usercentergetinfo,
  userlogin,
  obtainIp,
  PCIntoInsert,
  PcQuitUpate,
} from "@/api/home";
export default {
  data() {
    return {
      playerOptions: {
        live: true,
        autoplay: true,
        notSupportedMessage: "",
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          autoDisable: false,
          progressControl: true,
          fullscreenToggle: true, // 全屏按钮
        },
        // techOrder: ['flash'],
        // flash: {
        // 	hls: { withCredentials: false },
        // },
        // 封面
        poster: require("../../assets/img/默认页.png"),
        sources: [],
      },
      ruleForm: {
        name: "",
        region: "teacher",
        input: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写账号",
            trigger: "blur",
          },
        ],
        input: [
          {
            required: true,
            message: "请填写密码",
            trigger: "blur",
          },
        ],
        region: [
          {
            required: true,
            message: "请选择身份",
            trigger: "change",
          },
        ],
      },
      moimgs: "../../assets/img/默认页.png",
      dslist: "",
      lessonId: "",
      lessonVos: [],
      hui: false,
      lessonsid: "",
      netClassResTypeVos: [],
      activeName: "first",
      loading: false,
      textarea: "",
      parentId: "",
      replyRoleType: "",
      replyUserId: "",
      replyUserName: "",
      roleType: localStorage.getItem("roleType"),
      userId: localStorage.getItem("userId"),
      userName: localStorage.getItem("userName"),
      placeholder: "记录你的听课感受",
      courseId: "",
      curPage: 1,
      datalist: [],
      totalCount: 0,
      gklog: 0,
      huix: false,
      noteTime: 0,
      watchOver: 0,
      times: "",
      videoVoList: [],
      courseInfos: "",
      huifang: false,
      token: localStorage.getItem("token"),
      isHaveRight: "",
      dialogVisible: false,
      _gap_time: "",
      beforeUnload_time: "",
    };
  },
  watch: {},
  methods: {
    focuser() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$message.error("未登录，请登录后发表评论！！！");
      }
    },
    async lessonSetView() {
      const res = await lessonSetView({
        lessonId: this.lessonId,
      });
    },
    // 获取课程信息
    courselesson() {
      let that = this;
      that.loading = true;
      let params = {
        id: that.lessonId,
      };
      courselesson(params)
        .then((res) => {
          that.loading = false;

          that.dslist = res.data.data;
          that.courseInfos = that.dslist.netClassCourseVo.courseInfo;
          that.lessonVos = res.data.data.netClassCourseVo.lessonVos;
          that.isHaveRight = res.data.data.isHaveRight;

          that.huifangs();

          if (res.data.data.netClassResTypeVos !== null) {
            that.netClassResTypeVos = res.data.data.netClassResTypeVos;
            // that.activeName = res.data.data.netClassResTypeVos[0].restypeId.toString();
          } else {
            that.activeName = "first";
          }
          that.courseId = res.data.data.courseId;
          that.hui = true;

          if (
            res.data.data.fileModel !== null &&
            res.data.data.netClassCourseVo.courseTypeid == "2"
          ) {
            clearInterval(that.times);
            let list = [
              {
                type: "video/mp4",
                src: res.data.data.fileModel.fileUrl,
              },
            ];
            that.playerOptions.sources = list;
            that.notecheckIsExist();
          }
          if (
            res.data.data.fileModel == null ||
            res.data.data.netClassCourseVo.courseTypeid == "1"
          ) {
            if (res.data.data.liveStatus == 4) {
              that.playerOptions.controlBar.progressControl = true;

              clearInterval(that.times);

              that.videoVoList = res.data.data.videoVoList;

              // 处理回放目录显示时机问题

              // 处理时间秒问题
              that.videoVoList.forEach((item, index) => {
                that.videoVoList[index].beginTime = item.beginTime.slice(
                  0,
                  item.beginTime.lastIndexOf(":")
                );
                that.videoVoList[index].endTime = item.endTime.slice(
                  0,
                  item.endTime.lastIndexOf(":")
                );
              });

              that.lessonsid = that.videoVoList[0].videoId;
              let url =
                that.videoVoList[0].serverHttp + that.videoVoList[0].fileUrl;
              let list = [
                {
                  type: "video/mp4",
                  src: url,
                },
              ];
              that.playerOptions.sources = list;
              that.notecheckIsExist();
            } else if (res.data.data.liveStatus == 3) {
              clearInterval(that.times);
              // that.playerOptions.notSupportedMessage = "回放视频暂未上传。。。";
              that.playerOptions.poster = require("../../assets/img/回放.png");
              // that.$alert("回放视频生成中,请稍后再试！", "提示", {
              //   confirmButtonText: "确定",
              //   callback: (action) => {},
              // });
              let list = [
                {
                  type: "video/mp4",
                  src: "",
                },
              ];
              that.playerOptions.sources = list;
            } else if (res.data.data.liveStatus == 2) {
              // 直播封面特殊处理
              that.playerOptions.poster = this.lessonId == "10086" ? require("../../assets/img/qingfeng_zhibofengmian.jpg") : require("../../assets/img/直播未开始.png");
              // that.playerOptions.notSupportedMessage =
              //   "直播暂未开始，请稍后。。。";
              let list = [
                {
                  type: "video/mp4",
                  src: "",
                },
              ];
              that.playerOptions.sources = list;
            } else if (res.data.data.liveStatus == 1) {
              clearInterval(that.times);

              let list = [
                {
                  type: "application/x-mpegURL",
                  src: res.data.data.rtmpUrl,
                },
              ];
              that.playerOptions.sources = list;
            }
          }
          that.$refs.videoPlayer.player.play();
          that.notecheckIsExist();
          that.lessonsetview();
        })
        .catch(() => {
          that.loading = false;
        });
    },
    huifangs() {
      if (
        this.dslist.fileModel == null ||
        this.dslist.fileModel.serverId == "1"
      ) {

        if (!!this.dslist.videoVoList && this.dslist.videoVoList.length > 1) {
          this.huifang = true;
        }
      }
    },
    yula(s) {
      let url = "http://bk.welaiedu.cn/#/prepare_pdf?id=" + s;
      window.open(url, "_blank");
    },
    xuan(s) {
      this.lessonsid = s;
      this.lessonId = s;
      this.courselesson();
    },
    xuans(s, list) {
      this.lessonsid = s;
      this.lessonId = s;
      // this.courselesson();
      if (this.dslist.liveStatus == "1") {
        this.$message.error("正在直播中,请稍后查看");
        return false;
      }
      let url = list.serverHttp + list.fileUrl;
      let lists = [
        {
          type: "video/mp4",
          src: url,
        },
      ];
      this.playerOptions.sources = lists;
      that.$refs.videoPlayer.player.play();
    },
    lessonsetview() {
      let that = this;
      that.loading = true;
      let params = {
        lessonId: parseInt(that.lessonId),
      };
      lessonsetview(params)
        .then((res) => {
          that.loading = false;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    lessonfeeling() {
      let tokens = localStorage.getItem("token");
      if (!tokens) {
        this.$message.error("未登录，请登录后发表评论！！！");
        return false;
      }
      let that = this;
      that.loading = true;
      let params = {
        feelingContent: that.textarea,
        lessonId: that.lessonId,
        parentId: that.parentId,
        replyRoleType: that.replyRoleType,
        replyUserId: that.replyUserId,
        replyUserName: that.replyUserName,
        roleType: that.roleType,
        userId: that.userId,
        userName: that.userName,
        courseId: that.courseId,
      };
      lessonfeeling(params)
        .then((res) => {
          that.loading = false;
          that.textarea = "";
          that.parentId = "";
          that.replyRoleType = "";
          that.replyUserId = "";
          that.replyUserName = "";
          that.placeholder = "记录你的听课感受";
          that.lessonfeelinglist();
        })
        .catch(() => {
          that.loading = false;
        });
    },
    lessonfeelinglist() {
      let that = this;
      that.loading = true;
      let params = {
        curPage: that.curPage,
        pageSize: 5,
        lessonId: that.lessonId,
      };
      lessonfeelinglist(params)
        .then((res) => {
          that.loading = false;
          that.datalist = res.data.data.dataList;
          that.totalCount = res.data.data.totalCount;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    gai(s) {
      this.curPage = s;
      this.lessonfeelinglist();
    },
    shanchu(s) {
      let that = this;
      let params = {
        id: s,
      };
      this.$confirm("确定删除此条评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lessonfeelingdel(params)
            .then((res) => {
              that.loading = false;
              that.lessonfeelinglist();
            })
            .catch(() => {
              that.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          that.loading = true;
          let params = {
            roleType: that.ruleForm.region,
            account: that.ruleForm.name,
            password: that.ruleForm.input,
          };
          userlogin(params)
            .then((res) => {
              that.loading = false;
              if (res.data.code == "0") {
                localStorage.setItem("token", res.data.data.token);
                localStorage.setItem("roleType", that.ruleForm.region);
                that.dialogVisible = false;
                // this.$router.go(0);
                location.reload();
                that.usercentergetinfo();
              } else {
                that.$message(res.data.msg);
              }
            })
            .catch(() => {
              that.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    usercentergetinfo() {
      let that = this;
      usercenterinfo()
        .then((res) => {
          localStorage.setItem("roleType", res.data.data.roleType);
          if (res.data.data.roleType == "student") {
            that.names = res.data.data.student.name;
            that.schoolname = res.data.data.student.schoolName;
            localStorage.setItem("userId", res.data.data.userId);
            localStorage.setItem("schoolId", res.data.data.student.schoolId);
            that.schoolgetinfo(res.data.data.student.schoolId);
            localStorage.setItem(
              "classesId",
              res.data.data.student.gradeClassesInfo.classesId
            );
            localStorage.setItem("rosterNo", res.data.data.student.rosterNo);
          } else if (res.data.data.roleType == "teacher") {
            localStorage.setItem("teacherId", res.data.data.teacher.id);
            that.names = res.data.data.teacher.name;
            that.schoolname = res.data.data.teacher.schoolName;
            localStorage.setItem("schoolId", res.data.data.teacher.schoolId);
            that.schoolgetinfo(res.data.data.schoolId);
            that.shouw = true;
          } else {
            that.shouw = true;
            that.slhuif = true;
            that.names = res.data.data.school.name;
            that.schoolname = res.data.data.school.name;
            localStorage.setItem("schoolId", res.data.data.schoolId);
            that.schoolgetinfo(res.data.data.schoolId);
          }
          localStorage.setItem("userName", that.names);
          localStorage.setItem("userId", res.data.data.userId);
        })

        .catch(() => {});
    },
    huifu(s) {
      let that = this;
      that.parentId = s.feelingId;
      that.replyRoleType = s.roleName;
      that.replyUserId = s.userId;
      that.replyUserName = s.userName;
      that.placeholder = "@" + s.userName;
    },
    onPlayerTimeupdate(player) {
      this.gklog = player.cache_.currentTime;
    },
    playerReadied(player, vul) {
      player.currentTime(vul);
    },
    onPlayerEnded(player) {
      this.playerOptions.controlBar.progressControl = true;
      this.watchOver = 1;
    },
    onPlayerPlay(player) {
      // console.log('player play!', player)
      //   player.pause();
      //   player.play();
    },
    onPlayerPause(player) {
      // player.play();
      // player.pause();
    },
    note() {
      let that = this;
      // that.loading = true
      let params = {
        courseId: that.courseId,
        lessonId: that.lessonId,
        noteTime: that.gklog,
        roleType: that.roleType,
        userId: that.userId,
        watchOver: that.watchOver,
      };
      note(params)
        .then((res) => {
          // that.loading = false
        })
        .catch(() => {
          // that.loading = false
        });
    },
    notecheckIsExist() {
      let that = this;
      that.loading = true;
      let params = {
        lessonId: that.lessonId,
      };
      notecheckIsExist(params)
        .then((res) => {
          that.loading = false;
          that.noteTime = res.data.data.noteTime;
          if (res.data.data.watchOver == 1) {
            that.playerOptions.controlBar.progressControl = true;
            that.watchOver = 1;
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },

    hasUsableFlash() {
      var flashObj;
      if (typeof window.ActiveXObject != "undefined") {
        flashObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      } else {
        flashObj = navigator.plugins["Shockwave Flash"];
      }
      return flashObj ? true : false;
    },
    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },

  },
  beforeRouteLeave(to, form, next) {
    this.note();
    next();
  },
  destroyed() {
    // this.PcQuitUpate()
    // window.removeEventListener("beforeunload", (e) =>
    //   this.beforeunloadHandler(e)
    // );
    // window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },
  components: { videoPlayer },
  watch: {
    gklog() {
      if (!this.huix) {
        if (this.gklog > 0) {
          this.huix = true;
          this.playerReadied(this.$refs.videoPlayer.player, this.noteTime);
        }
      }
    },
  },
  computed: {
    // player() {
    // 	that.$refs.videoPlayer.player.play()
    // },
  },
  created() {
    this.lessonId = this.$route.query.id;
    this.lessonsid = this.$route.query.id;
    this.courselesson();
    this.lessonSetView();
    clearInterval(this.times);
  },
  // deforeDestroy(){
  //   console.log('销毁');
  //   this.PcQuitUpate();

  // },
  mounted() {
    // 离开页面时清空定时器以防再次进入页面错乱 有需要可以放开
    // this.$once("hook:beforeDestroy", () => {
    //   // clearInterval(this.times);
    //   this.PcQuitUpate();
    // });
    this.lessonfeelinglist();
    this.times = setInterval(() => {
      this.courselesson();
    }, 60000);
    // setInterval(() => {
    //   console.log(0);
    // }, 3000);
    window.addEventListener("beforeunload", (e) => {
      this.note();
    });
    window.setInterval(() => {
      setTimeout(this.note(), 0);
    }, 300000);
    let that = this;
    window.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        that.$refs.videoPlayer.player.pause();
      } else {
        that.$refs.videoPlayer.player.play();
      }
    });

    // window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    // window.addEventListener("unload", (e) => this.unloadHandler(e));
  },
};
</script>

<style>
.vjs-error .vjs-error-display:before {
  display: none;
}
.vjs-modal-dialog .vjs-modal-dialog-content {
  line-height: 595px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue